import React from 'react';
import { FolloupList } from '../components';

export default () => {
    return (
        <FolloupList.Home />
    )
}